export default __webpack_public_path__ + "static/media/480_dummy2016-zahnarzt01-mobile-de.1d9b3f9b.png";